import {
  AUTH_LOGIN,
  AUTH_PROFILE,
  PROFILE_LIMITS,
  type ProfilePhoneFormProps,
} from '../constants/auth'
import { profilePhoneSubmitLabel } from '../helpers/auth'

export function ProfilePhoneForm({
  label,
  value,
  onChange,
  otp,
  onOtpChange,
  otpSentTo,
  onSubmit,
  onResend,
  onCancel,
  pending,
  error,
}: ProfilePhoneFormProps) {
  const busy = pending !== null
  const submitLabel = profilePhoneSubmitLabel(Boolean(otpSentTo), pending)

  return (
    <form className="profile-page__form" onSubmit={onSubmit}>
      <div className="profile-page__mobile">
        <span className="profile-page__mobile-code">{AUTH_LOGIN.countryCode}</span>
        <input
          aria-label={label}
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder={AUTH_PROFILE.phonePlaceholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          minLength={PROFILE_LIMITS.phoneDigits}
          maxLength={PROFILE_LIMITS.phoneDigits}
          required
          autoFocus
          disabled={busy}
        />
      </div>
      {otpSentTo ? (
        <>
          <p className="profile-page__hint">{AUTH_PROFILE.phoneOtpHint(otpSentTo)}</p>
          <input
            aria-label={AUTH_LOGIN.otpLabel}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder={AUTH_PROFILE.otpPlaceholder}
            value={otp}
            onChange={(event) => onOtpChange(event.target.value)}
            minLength={PROFILE_LIMITS.otpMin}
            maxLength={PROFILE_LIMITS.otpMax}
            required
            autoFocus
            disabled={busy}
          />
        </>
      ) : null}
      {error ? (
        <p className="profile-page__error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="profile-page__actions">
        <button type="submit" className="profile-page__save" disabled={busy}>
          {submitLabel}
        </button>
        {otpSentTo ? (
          <button
            type="button"
            className="profile-page__cancel"
            onClick={onResend}
            disabled={busy}
          >
            {AUTH_PROFILE.resendOtp}
          </button>
        ) : null}
        <button type="button" className="profile-page__cancel" onClick={onCancel} disabled={busy}>
          {AUTH_PROFILE.cancel}
        </button>
      </div>
    </form>
  )
}
